// extracted by mini-css-extract-plugin
export var container = "_jp-0";
export var dotAnimation = "_jp-2";
export var dotsLoading = "_jp-1";